// ##### Komarov 2025-07-12
import React, { useEffect } from 'react';
// ##### 23-09-14 Komarov
// import './SearchItems.css'
import moment from 'moment';
// ##### 24-07-25 Komarov
import { useSelector } from 'react-redux';

// ##### Komarov 2025-07-14
const MinRate = ({ selection, datesArray, pickedCurrency }) => {
  // ##### Komarov 2025-07-12
  const language = useSelector(state => state.language);
  useEffect(() => {
    moment.locale(language);
  }, [language]);
  // console.log('[SELECTION]' , selection, datesArray)

  // const currencies = useSelector(state=>state.currency.currencies)

  // ##### 24-07-25 Komarov
  const currenciesFromState = useSelector(state => state.currency.currencies);
  // ##### 24-03-21 Komarov
  const currencies =
    (currenciesFromState.length > 0 && currenciesFromState) ||
    JSON.parse(localStorage.getItem('currency')).currencies;

  let exchangeRate;

  // ##### 24-03-21 Komarov
  for (const curr of currencies) {
    if (curr.name === pickedCurrency) exchangeRate = parseInt(curr.value);
  }

  // ##### 24-03-21 Komarov
  const minRateValue = datesArray
    .filter(item => {
      return selection === item.date;
    })
    .sort((a, b) => a.n_value - b.n_value);

  // console.log('[SORTED ARRAY] : ' , minRateValue[0])

  // ##### 24-04-13 Komarov: TODO: Взять перевод "Rates from" из Смарта
  return (
    <div className="minimumRate_details" data-component="MinRate">
      {/* ##### 24-04-13 Komarov */}
      {/* Rates from {pickedCurrency} {Math.round(minRateValue[0].price/exchangeRate)} */}
      Rates from {pickedCurrency}{' '}
      {parseFloat(minRateValue[0].price / exchangeRate).toFixed(2)}
    </div>
  );
};

export default MinRate;
